import { ResponseError } from '@backstage/errors';

class AwsApiClient {
  backendName;
  discoveryApi;
  fetchApi;
  constructor(options) {
    this.backendName = options.backendName;
    this.fetchApi = options.fetchApi;
    this.discoveryApi = options.discoveryApi;
  }
  async getBaseUrl() {
    return this.discoveryApi.getBaseUrl(this.backendName);
  }
  async get(path) {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/${path}`;
    const response = await this.fetchApi.fetch(url);
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
}

export { AwsApiClient };
//# sourceMappingURL=AwsApiClient.esm.js.map
